import React from "react"
import { AppDispatch } from "../../../reduxStore/store"
import {
  ErrorState,
  selectErrorHandler,
  initialState as initialInfoState,
  errorHandlerUpdated,
} from "../errorSlice"
import { useDispatch, useSelector } from "react-redux"
import { Banner } from "../../shared/components/Banner"
import cn from "../../../utils/classes"

interface InfoBannerProps {
  styleOverrides?: string
  disableClose?: boolean
}

/**
 * @deprecated Use BannerWithId and bannersWithId state instead. This component uses the legacy infoBanner state.
 */
export const InfoBanner: React.FC<InfoBannerProps> = ({
  disableClose,
  styleOverrides,
}) => {
  const dispatch: AppDispatch = useDispatch()

  const errorState: ErrorState = useSelector(selectErrorHandler)

  const infoBannerState = errorState.infoBanner

  const handleOnBannerClose = () => {
    const payload: Partial<ErrorState> = {
      infoBanner: initialInfoState.infoBanner,
    }
    dispatch(errorHandlerUpdated(payload))

    infoBannerState.onClose?.()
  }

  const className = cn(styleOverrides)

  return (
    <Banner
      type="info"
      title={infoBannerState.title}
      content={infoBannerState.content}
      isOpen={infoBannerState.isVisible}
      onClose={disableClose ? undefined : handleOnBannerClose}
      id="profile-card"
      sticky={true}
      styleOverrides={`${className} z-10`}
      contentStyleOverrides="text-base"
      titleStyleOverrides="text-base"
    />
  )
}

export default InfoBanner
